import { render, staticRenderFns } from "./PatientSaveButton.vue?vue&type=template&id=1c9ed01f&"
import script from "./PatientSaveButton.vue?vue&type=script&lang=js&"
export * from "./PatientSaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports